<h3 mat-dialog-title data-test-id="missing-field-dialog.title">
    We need a little more information to submit your application.
</h3>
<form #f="ngForm" class="m-form m-form--group-seperator-dashed missing-field-form" novalidate
      data-test-id="missing-field-dialog.form">
    <mat-dialog-content>
        <div class="missing-field-applicant" *ngFor="let entry of entries; let i = index"
             [attr.data-test-id]="'missing-field-dialog.applicant-' + i">
            <p class="mb-1" [attr.data-test-id]="'missing-field-dialog.applicant-name-' + i">
                {{fullName(entry.applicant)}} ({{roleLabel(entry.applicant.applicantType)}})
            </p>
            <creditsnap-ssn [(ngModel)]="entry.ssn" (ngModelChange)="updateButtonState()"
                            name="ssn-{{i}}" id="missing-field-ssn-{{i}}" [hide]="false"
                            [data-test-id]="'missing-field-dialog.ssn-' + i"></creditsnap-ssn>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="justify-content-center">
        <p class="mat-error" *ngIf="errorMessage" data-test-id="missing-field-dialog.error-message">{{errorMessage}}</p>
        <div class="page-actions w-100">
            <mat-bar-button [options]="barButtonOptions" (tsSubmitIfValid)="onSubmit('missing-field-submit-btn')"
                            data-test-id="missing-field-dialog.submit-button">
            </mat-bar-button>
            <button mat-button type="button" class="mt-2" [disabled]="barButtonOptions.active"
                    (click)="onCancel('missing-field-cancel-btn')" data-test-id="missing-field-dialog.cancel-button">
                Cancel
            </button>
        </div>
    </mat-dialog-actions>
</form>
